import { SerializedError } from '@reduxjs/toolkit';

export enum ErrorName {
  AUTH_ERROR = 'AuthError',
  AREENA_MEDIA_FETCH_ERROR = 'AreenaMediaFetchError',
  NOT_FOUND_ERROR = 'NotFoundError',
  CONSENT_ERROR = 'ConsentError',
  SERVER_ERROR = 'ServerError',
  TIMEOUT_ERROR = 'TimeoutError',
  NETWORK_ERROR = 'NetworkError',
  UNKNOWN_ERROR = 'UnknownError',
  EXPIRED_SESSION_ERROR = 'ExpiredSessionError',
  LOGIN_API_ERROR_5XX = 'LoginApiError5xx',
  ADD_FAVORITE_ERROR = 'AddFavoriteError',
  REMOVE_FAVORITE_ERROR = 'RemoveFavoriteError',
  ERROR = 'error',
  SILENT_ERROR = 'SilentError',
  CONFLICT_ERROR = 'ConflictError',
}

export class AuthError extends Error {
  readonly name = ErrorName.AUTH_ERROR;
}

export class AreenaMediaFetchError extends Error {
  readonly name = ErrorName.AREENA_MEDIA_FETCH_ERROR;
}

export class NotFoundError extends Error {
  readonly name = ErrorName.NOT_FOUND_ERROR;
}

export class ConsentError extends Error {
  readonly name = ErrorName.CONSENT_ERROR;
}

export class ServerError extends Error {
  readonly name = ErrorName.SERVER_ERROR;
}

export class TimeoutError extends Error {
  readonly name = ErrorName.TIMEOUT_ERROR;
}

export class NetworkError extends Error {
  readonly name = ErrorName.NETWORK_ERROR;
}

export class UnknownError extends Error {
  readonly name = ErrorName.UNKNOWN_ERROR;
}

export class ExpiredSessionError extends Error {
  sessionCookie?: string;
  userId?: string;

  constructor(message?: string, sessionCookie?: string, userId?: string) {
    super(message);
    this.sessionCookie = sessionCookie;
    this.name = ErrorName.EXPIRED_SESSION_ERROR;
    this.userId = userId;
  }
}

export class LoginApiError5xx extends Error {
  readonly name = ErrorName.LOGIN_API_ERROR_5XX;
  sessionCookie?: string;

  constructor(message?: string, sessionCookie?: string) {
    super(message);
    this.sessionCookie = sessionCookie;
  }
}

export class AddFavoriteError extends Error {
  readonly name = ErrorName.ADD_FAVORITE_ERROR;
}

export class RemoveFavoriteError extends Error {
  readonly name = ErrorName.REMOVE_FAVORITE_ERROR;
}

export class SilentError extends Error {
  readonly name = ErrorName.SILENT_ERROR;
}

export class ConflictError extends Error {
  readonly name = ErrorName.CONFLICT_ERROR;
}

export interface LeanbackSerializedError extends SerializedError {
  sessionCookie?: string;
  userId?: string;
}
